import { useTranslation } from "react-i18next";
import type { SupportedLocale } from "../i18n";
import { SUPPORTED_LOCALES } from "../i18n";

const LOCALE_LABELS: Record<SupportedLocale, string> = {
  en: "English",
  es: "Español",
  "fr-CA": "Français",
};

interface Props {
  allowed?: string[];
}

export function LanguagePicker({ allowed }: Props) {
  const { i18n, t } = useTranslation();
  const current = i18n.language as SupportedLocale;
  const options = allowed
    ? SUPPORTED_LOCALES.filter((l) => allowed.includes(l))
    : SUPPORTED_LOCALES;

  if (options.length <= 1) return null;

  return (
    <div className="flex items-center gap-2" aria-label={t("language.label")}>
      {options.map((locale) => (
        <button
          key={locale}
          onClick={() => void i18n.changeLanguage(locale)}
          className={`px-4 py-2 rounded-full text-lg font-medium transition-colors ${
            current === locale
              ? "bg-[var(--kiosk-brand-accent)] text-white"
              : "bg-[var(--kiosk-brand-surface)] text-[var(--kiosk-brand-text)] border border-[var(--kiosk-brand-muted)]"
          }`}
          aria-pressed={current === locale}
        >
          {LOCALE_LABELS[locale]}
        </button>
      ))}
    </div>
  );
}
